import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-42d325e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 20px"}
}

import { reactive, ref, PropType, computed } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType, TABLE_PREVIEW_PAGE_SIZE, TABLE_FULL_PAGE_SIZE_DEFAULT } from '@/views/dashboard/_enum/table-view-mode'
import { TerminalViewService, TerminalItem, TerminalQueryParams } from './terminal-view/terminal-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { PermissionFe } from '@/services/service-permission.service'
import TerminalIconName from '@/views/dashboard/_components/terminal-icon-name/terminal-icon-name.vue'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'
import PopupDetailList from './popup-detail-list.vue'
import { FormType } from '@/components/cmForm/types'
import { ElMessage, ElMessageBox } from 'element-plus'

const DefaultStatus = 3

export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-list',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  hasPermission: {
    type: Boolean,
    default: false
  }
},
  emits: ["selectionChange", "viewAll"],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const terminalStatus = computed(() => [
  { label: t('popupIntercept.filterAll'), value: 3 },
  { label: t('popupIntercept.filterOnline'), value: 1 },
  { label: t('popupIntercept.filterOffline'), value: 2 }
])

const props = __props

const emits = __emit

const injector = useReflectiveInjector([TerminalViewService])
const terminalViewService = injector.get(TerminalViewService)
const dataApi = terminalViewService.getListByServer.bind(terminalViewService)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const selectedIds = ref<string[]>([])
const selectedRows = ref<TerminalItem[]>([])
const popupDrawerVisible = ref(false)
const currentTerminal = ref<TerminalItem | null>(null)

const queryParams = reactive<TerminalQueryParams>({
  key_word: '',
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? TABLE_PREVIEW_PAGE_SIZE : TABLE_FULL_PAGE_SIZE_DEFAULT,
  sort: '',
  asc: false,
  login_status: DefaultStatus,
  permission_name: PermissionFe.popwindow_block,
  useMemory: false
})

const tableOpt = computed<TableOpt>(() => ({
  bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
  columns: [
    { prop: 'computer_name', type: 'COMPUTER', label: t('popupIntercept.computerName'), columnOpt: { minWidth: 180 } },
    { prop: 'user_mark', label: t('popupIntercept.registerUser'), columnOpt: { minWidth: 120 } },
    { prop: 'ip', type: 'IP', label: t('popupIntercept.ipAddress'), columnOpt: { minWidth: 200 } },
    {
      prop: 'login_status',
      label: t('popupIntercept.terminalStatus'),
      sortable: 'custom',
      formatter: (_row, val) => val === 1 ? t('popupIntercept.filterOnline') : t('popupIntercept.filterOffline'),
      columnOpt: { minWidth: 100 }
    },
    {
      prop: 'auto_intercept_switch',
      label: t('popupIntercept.autoIntercept'),
      formatter: (_row, val) => val === 1 ? t('popupIntercept.switchOn') : t('popupIntercept.switchOff'),
      columnOpt: { minWidth: 100 }
    },
    { prop: 'popup_count', label: t('popupIntercept.popupSoftwareCount'), columnOpt: { minWidth: 120 } }
  ],
  rowKey: 'device_id',
  selection: true,
  path: 'list',
  height: props.viewMode === TableViewMode.preview ? undefined : '100%',
  hiddenPageTool: props.viewMode === TableViewMode.preview,
  disableScrollLoad: props.viewMode === TableViewMode.preview
}))

const tableActOpt = computed<TableActOpt>(() => ({
  isLink: false,
  height: '100%',
  columnOpt: { label: t('popupIntercept.operation'), width: 120, align: 'left' },
  actionButtons: () => []
}))

const filterFormColumns = computed(() => [
  {
    prop: 'login_status',
    outSearchFiledFlag: true,
    hiddenAllLabel: true,
    selectOpt: { clearable: true },
    label: t('popupIntercept.terminalStatus'),
    colOpt: { style: 'flex: 0 0 150px' },
    type: FormType.Select,
    dictData: terminalStatus.value,
    events: { change: handleQuery }
  }
])

function handleSelectionChange(selection: TerminalItem[], ids: string[]) {
  selectedRows.value = selection ?? []
  selectedIds.value = ids ?? []
  emits('selectionChange', ids)
}

function handleSearch(val) {
  queryParams.key_word = val
  queryParams.page = 1
  void refreshList()
}

async function handleQuery() {
  queryParams.page = 1
  await refreshList()
}

function handleReset() {
  queryParams.key_word = ''
  queryParams.login_status = DefaultStatus
  queryParams.page = 1
  void refreshList()
}

function openPopupDrawer(row: TerminalItem) {
  currentTerminal.value = row
  popupDrawerVisible.value = true
}

async function handleScanReport() {
  if (!selectedRows.value.length) return
  try {
    await ElMessageBox.confirm(t('popupIntercept.confirmScanReport'), t('cmtable.tip'), {
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    })
  } catch {
    return
  }
  const ids = selectedRows.value.map((item) => item.device_id)
  try {
    await terminalViewService.scanReport({ execute_type: 0, device_list: ids, group_id: -1 })
    ElMessage.success(t('popupIntercept.scanReportSuccess', { count: ids.length }))
  } catch {
    ElMessage.error(t('popupIntercept.scanReportFailed', { count: ids.length }))
  }
}

async function handleEnableAutoIntercept() {
  if (!selectedRows.value.length) return
  const ids = selectedRows.value.map((item) => item.device_id)
  try {
    await terminalViewService.updateEngine({ execute_type: 0, device_list: ids, group_id: -1, engine: 2 })
    ElMessage.success(t('popupIntercept.enableAutoInterceptSuccess', { count: ids.length }))
    tableRef.value?.tableRef?.clearSelection?.()
    selectedRows.value = []
    selectedIds.value = []
    void refreshList()
  } catch {
    ElMessage.error(t('popupIntercept.enableAutoInterceptFailed', { count: ids.length }))
  }
}

__expose({
  tableRef,
  selectedIds
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      tableOpt: tableOpt.value,
      tableActOpt: tableActOpt.value,
      firstLoading: true,
      "has-permission": __props.hasPermission,
      api: _unref(dataApi),
      modelValue: queryParams,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
      pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
      onChangeSelected: handleSelectionChange
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: queryParams,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
          "form-columns": filterFormColumns.value,
          disabled: !__props.hasPermission,
          "show-search": true,
          "search-placeholder": _ctx.$t('popupIntercept.searchPlaceholderTerminal'),
          "popover-threshold": 2,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              disabled: !selectedRows.value.length || !__props.hasPermission,
              onClick: handleScanReport
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('popupIntercept.scanReport')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              plain: "",
              disabled: !selectedRows.value.length || !__props.hasPermission,
              onClick: handleEnableAutoIntercept
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('popupIntercept.enableAutoIntercept')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            (__props.viewMode === _unref(TableViewMode).preview)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  type: "",
                  plain: "",
                  disabled: !__props.hasPermission,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('viewAll')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
      ]),
      popup_count: _withCtx((scope) => [
        (scope.row?.popup_count)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: ($event: any) => (openPopupDrawer(scope.row)),
              type: "text",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row?.popup_count), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, "0"))
      ]),
      _: 1
    }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: 800,
      modelValue: popupDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((popupDrawerVisible).value = $event)),
      direction: "rtl",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('popupIntercept.popupListTitle', { name: currentTerminal.value?.computer_name || '' })), 1),
        _createVNode(PopupDetailList, {
          "device-id": currentTerminal.value?.device_id
        }, null, 8, ["device-id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})